import { useEffect, useRef, useMemo } from 'react';

import type { BaseField, FieldDescriptor, StaticFieldProps } from '../../types/common';

export type HiddenFieldType = BaseField & {
  type: 'HiddenField';
  goToNextSection?: string;
  defaultValue: any;
  resetValue?: string | number | null | undefined | object;
};

function HiddenField({
  onNextSectionClick,
  field,
  onValueChange,
  value,
}: StaticFieldProps<HiddenFieldType>) {
  const hasResetRef = useRef(false);

  const resetValueString = useMemo(
    () => (field?.resetValue !== undefined ? JSON.stringify(field.resetValue) : null),
    [field?.resetValue]
  );

  useEffect(() => {
    if (field?.goToNextSection) {
      onNextSectionClick?.();
    }
  }, [onNextSectionClick, field?.goToNextSection]);

  useEffect(() => {
    if (resetValueString && onValueChange && !hasResetRef.current) {
      const currentValueString = value ? JSON.stringify(value) : null;

      if (currentValueString !== resetValueString) {
        hasResetRef.current = true;
        onValueChange(field.resetValue);

        setTimeout(() => {
          hasResetRef.current = false;
        }, 0);
      }
    }
  }, [resetValueString, onValueChange, value, field?.resetValue]);

  return null;
}

const Descriptor: FieldDescriptor<HiddenFieldType> = {
  FieldComponent: HiddenField,
  name: 'HiddenField',
  renderIfHidden: true,
  rendersNull: true,
};

export default Descriptor;
